import React, { Component } from "react";

class ItemStatusBar extends Component {

  componentDidMount() {
    const {getTrackOrderData, selectedProduct, eventId} = this.props;
    getTrackOrderData(eventId, selectedProduct.purchaseItemId, selectedProduct.pedidoNo);
  }

  render() {
    const { trackOrderData, loadingTrackOrder, trackOrderFailed } = this.props;
    const orderTrackInfo = trackOrderData && trackOrderData.orderTrackInfo || '';
    const steps = [
      "Confirmado", 
      "Preparando", 
      "Listo para recoger",
      "Entregado"
    ];
    const stageSteps = ["stage1", "stage2", "stage3", "stage4"];

    const stageLevel = orderTrackInfo && orderTrackInfo.stageLevel || "stage1";
    const currentIndex = stageSteps.indexOf(stageLevel);

    let currentStageDate = '';

    if(orderTrackInfo.stageLevel === "stage1"){
      currentStageDate = orderTrackInfo.stage1Date;
    } else if(orderTrackInfo.stageLevel === "stage2"){
      currentStageDate = orderTrackInfo.stage2Date;
    } else if(orderTrackInfo.stageLevel === "stage3"){
      currentStageDate = orderTrackInfo.stage3Date;
    } else if(orderTrackInfo.stageLevel === "stage4"){
      currentStageDate = orderTrackInfo.stage4Date;
    }

    const dotPositions = [0, 109, 205, 300];
    const progressWidth =
      currentIndex > 0 ? `${dotPositions[currentIndex]}px` : "0px";
    const activeDotLeft = dotPositions[currentIndex];

    return (
      <div className="status-bar-wrapper">
        {trackOrderFailed ? (
          'Intente nuevamente más tarde'
        ) : loadingTrackOrder ? (
          'Sección de orden de carga...'
        ) : (
        (!loadingTrackOrder && currentStageDate) ? 
        <div className="status-bar-container">
          {/* Background and filled progress lines */}
          <div className="progress-line-track"></div>
          <div
            className="progress-line-fill"
            style={{ width: progressWidth }}
          />

          {/* Dots + Checkmark */}
          <div className="dots-layer">
            {steps.map((step, index) => {
              const isActive = index === currentIndex;
              const isCompleted = index < currentIndex;

              const dotClass = isActive
                ? "dot active-dot"
                : isCompleted
                ? "dot completed-dot"
                : "dot pending-dot";

              return (
                <React.Fragment key={index}>
                  <div
                    className={dotClass}
                    style={{ left: `${dotPositions[index]}px` }}
                  />
                  {isActive && (
                    <div
                      className="check-circle"
                      style={{ left: `${dotPositions[index] + 1.5}px` }}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {/* Labels below dots */}
          {steps.map((label, index) => {
            const labelClasses = `progress-label label-${index + 1} ${
              currentIndex === index ? "label-active" : ""
            }`;
            return (
              <div className={labelClasses} key={label}>
                {label}
              </div>
            );
          })}

          {/* Delivery date */}
          <div
            className="delivery-date"
            style={{ left: `${activeDotLeft + 4}px`, textAlign: 'center' }}
          >
            {currentStageDate}
          </div>
        </div> : 'Intente nuevamente más tarde'
        )}
      </div>
    );
  }
}

export default ItemStatusBar;
